import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { withNamespaces } from 'react-i18next';

class CheckoutForm extends Component {
	constructor(props) {
		super(props);

		this.handleVoucherSchemeNameChange = this.handleVoucherSchemeNameChange.bind(this);
		this.handleVoucherSchemeReferenceChange = this.handleVoucherSchemeReferenceChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.state = {
			voucherSchemeName: '',
			voucherSchemeReference: ''
		};
	}

	componentDidMount() {
		this.props.setVoucherDataSubmit(this.handleSubmit);
	}

	handleVoucherSchemeNameChange(e) {
		this.setState({ voucherSchemeName: e.target.value });
	}

	handleVoucherSchemeReferenceChange(e) {
		this.setState({ voucherSchemeReference: e.target.value });
	}

	handleSubmit() {
		return this.state;
	}

	render() {
		const { t } = this.props;
		const labelStyle = { border: 'none', padding: '0 5px' };

		return (
			<Form>
				<FormGroup controlId='voucherSchemeName'>
					<ControlLabel style={labelStyle}>{t('FO_PaymentMethod_Voucher_SchemeName')}<em style={{ color: '#D62229' }}>*</em></ControlLabel>
					<FormControl type='text'
						value={this.state.voucherSchemeName}
						onChange={this.handleVoucherSchemeNameChange} />
				</FormGroup>
				<FormGroup controlId='voucherSchemeReference'>
					<ControlLabel style={labelStyle}>{t('FO_PaymentMethod_Voucher_SchemeReference')}<em style={{ color: '#D62229' }}>*</em></ControlLabel>
					<FormControl type='text'
						value={this.state.voucherSchemeReference}
						onChange={this.handleVoucherSchemeReferenceChange} />
				</FormGroup>
			</Form>
		);
	}
}

export default withNamespaces()(CheckoutForm);
